import React, { useEffect, useState } from "react";
import { Tabs, Tab } from "@mui/material";
import { FaArrowUp, FaArrowDown, FaChartBar } from "react-icons/fa";
import { useLocation } from "react-router-dom";
import PDCIssued from "./PDCIssued";
import PDCRecieved from "./PDCRecieved";
import PDCReports from "./PDCReports";
import axios from "axios";

const PDCDashboard = () => {
  const COMPANY_CODE = localStorage.getItem("companyCode") || "-";
  const [tabIndex, setTabIndex] = useState(0);
  const [searchTerm, setSearchTerm] = useState("");
  const location = useLocation();
  const [defaultPDCAccountData, setDefaultPDCAccountData] = useState([]);

  const CustomTab = ({ label, icon, ...props }) => {
    return (
      <Tab
        label={
          <span className="flex items-center space-x-2">
            <span className="text-lg transition-transform duration-200 group-hover:scale-110 group-[.Mui-selected]:scale-110 group-[.Mui-selected]:text-white">
              {icon}
            </span>
            <span className="font-semibold group-[.Mui-selected]:text-white">
              {label}
            </span>
          </span>
        }
        className={` group relative text-sm font-medium 
               transition-all duration-300 ease-in-out
               hover:text-indigo-600 hover:bg-indigo-100 hover:shadow-sm hover:scale-90 hover:rounded-md
               [&.Mui-selected]:text-white 
               [&.Mui-selected]:bg-indigo-600
               [&.Mui-selected]:border-b-4 [&.Mui-selected]:border-indigo-200
               [&.Mui-selected]:shadow-md
               [&.Mui-selected]:rounded-md
               focus:outline-none focus:ring-0 focus:ring-none focus:ring-opacity-0 text-white
               px-4 py-3 rounded-t-lg
               min-w-[120px] md:min-w-[150px]`}
        sx={{
          "&:focus": {
            zIndex: 10,
          },
        }}
        aria-label={label}
        {...props}
      />
    );
  };

  useEffect(() => {
    const tabIndexFromChild = location.state?.tabIndex;

    if (typeof tabIndexFromChild === "number") {
      setTabIndex(tabIndexFromChild);
    } else {
      setTabIndex(0); // default when not from supplier creation
    }

    window.history.replaceState({}, document.title);
  }, [location.state]);

  const handleTabChange = (event, newValue) => {
    setTabIndex(newValue);
  };

  useEffect(() => {
    fetchDefaultPDCAccount();
  }, []);

  const fetchDefaultPDCAccount = async () => {
    let department = localStorage.getItem("currentSelectedDepartment") || "-";
    let apiPaths = JSON.parse(localStorage.getItem("apiPaths") || "[]");
    let url = `${apiPaths[0]?.API_CONFIG}/api/CRMGLSettings/${COMPANY_CODE}/SCRN_CODE/PD/-/${department}/-`;
    try {
      const response = await axios.get(url);
      setDefaultPDCAccountData(response.data || []);
    } catch (err) {
      console.error("Error while loading Voucher Type List:", err);
    }
  };

  console.log("in parent PDC defaultPDCAccountData:", defaultPDCAccountData);

  const issueStoreAccounts = defaultPDCAccountData.filter(
    (item) => item.Scrn_code === "PDC-ISS-D" || item.Scrn_code === "PDC-ISS-C",
  );

  const receiveStoreAccounts = defaultPDCAccountData.filter(
    (item) => item.Scrn_code === "PDC-RCV-D" || item.Scrn_code === "PDC-RCV-C",
  );

  console.log("Issue Store Data:", issueStoreAccounts);
  console.log("Receive Store Data:", receiveStoreAccounts);

  return (
    <div className="mx-4">
      <h2 className="text-xl text-gray-800 mb-4">PDC Dashboard</h2>

      <div className=" border-b  p-2 flex justify-between items-center">
        <div className="rounded-md">
          <Tabs
            value={tabIndex}
            onChange={handleTabChange}
            className=""
            TabIndicatorProps={{
              className: "hidden", // Hide default MUI indicator
            }}
          >
            <CustomTab label="PDC Issued" icon={<FaArrowUp className="" />} />
            <CustomTab
              label="PDC Recieved"
              icon={<FaArrowDown className="" />}
            />
            <CustomTab label="PDC Reports" icon={<FaChartBar className="" />} />
          </Tabs>
        </div>
        <div>
          <input
            type="text"
            placeholder="Search by name, type no, chq no, amount..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="border border-gray-300 rounded-md px-2 py-1 w-72"
          />
        </div>
      </div>

      <div className="">
        <div hidden={tabIndex !== 0}>
          <PDCIssued issueStoreAccounts={issueStoreAccounts} searchTerm={searchTerm} />
        </div>
        <div hidden={tabIndex !== 1}>
          <PDCRecieved receiveStoreAccounts={receiveStoreAccounts} searchTerm={searchTerm} />
        </div>
        <div hidden={tabIndex !== 2}>
          <PDCReports searchTerm={searchTerm} />
        </div>
      </div>
    </div>
  );
};

export default PDCDashboard;
